module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Teracota.b6d95e9b.jpg";